import { DEFAULT_CURRENCY } from '~/shared/constants/currencyConstants'
import { IAppState } from '~/shared/store/types'
import { ISubscription } from '~/shared/types/subscriptionsTypes'

export const selectSelectedSubscription = (state: IAppState) =>
  state.subscription.selectedSubscription || null
export const selectSelectedSubscriptionID = (state: IAppState): string =>
  state.subscription.selectedSubscription?.id || ''
export const selectSelectedSubscriptionPlanID = (state: IAppState): number =>
  state.subscription.selectedSubscription?.planId || 0
export const selectSelectedSubscriptionLookupKey = (state: IAppState): string =>
  state.subscription.selectedSubscription?.lookupKey || ''
export const selectSelectedSubscriptionTrialLookupKey = (
  state: IAppState,
): string => state.subscription.selectedSubscription?.trialLookupKey || ''
export const selectSelectedSubscriptionPeriodQuantity = (
  state: IAppState,
): number =>
  state.subscription.selectedSubscription?.mainPrices.periodQuantity || 0
export const selectSelectedSubscriptionPeriodName = (
  state: IAppState,
): string =>
  state.subscription.selectedSubscription?.mainPrices.periodName || ''
export const selectSelectedSubscriptionFullPrice = (state: IAppState): number =>
  state.subscription.selectedSubscription?.mainPrices.fullPrice || 0
export const selectSelectedSubscriptionCurrency = (state: IAppState): string =>
  state.subscription.selectedSubscription?.currency || DEFAULT_CURRENCY
export const selectSelectedSubscriptionTrialPrice = (
  state: IAppState,
): number => state.subscription.selectedSubscription?.trialPrices.fullPrice || 0
export const selectSelectedSubscriptionTrialDays = (state: IAppState): number =>
  state.subscription.selectedSubscription?.trialPrices.durationDays || 0
export const selectPurchasedSubscriptionID = (state: IAppState): string =>
  state.subscription.purchasedSubscriptionId
export const selectSelectedSubscriptionProductID = (state: IAppState): string =>
  state.subscription.selectedSubscription?.product || ''
export const selectIsSelectedSubscriptionOneTime = (
  state: IAppState,
): boolean => Boolean(state.subscription.selectedSubscription?.isOneTime)
export const selectSubscriptionList = (state: IAppState): ISubscription[] =>
  state.subscription.subscriptionsList
